import React from 'react';

import Loadable from 'Shared/Loadable';
import useMatchMediaQuery from 'Shared/Hooks/useMediaQuery';
import { shouldShowCookiesMessage } from 'Jsx/MainMenu/utils';

const SHOULD_LOAD_COOKIES =
  typeof window === 'undefined' ? false : shouldShowCookiesMessage();

const LazyCookiesBar: React.FC = () => {
  const { matches: isDesktop } = useMatchMediaQuery('md');

  if (isDesktop && SHOULD_LOAD_COOKIES) {
    return (
      <Loadable
        module={() =>
          import(/* webpackChunkName: "main-menu-cookiesbar" */ './CookiesBar')
        }
      />
    );
  }

  return null;
};

export default LazyCookiesBar;
